import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function UploadConstraints({
  extensions = ['.png', '.jpg'],
  size = '1', // size in MB
  maxSize = '4', // size in MB
  dimensions = '',
  className = ''
}) {
  return (
    <div className={cn(styles.container, className)}>
      <div>
        Image Formats Supported: <strong>{extensions.join(', ')}</strong>
      </div>
      {dimensions && (
        <div>
          Recommended dimensions: <strong>{dimensions}</strong>
        </div>
      )}
      <div>
        Recommended Size:{' '}
        <strong>
          {size}MB or less (Max {maxSize}MB)
        </strong>
      </div>
    </div>
  );
}
